import listModelValidator from './list';

export default listModelValidator;
